import React from "react";

export function IconTranslate() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 11.875H15V13.125H11.25V11.875ZM11.25 9.375H18.75V10.625H11.25V9.375ZM11.25 6.875H18.75V8.125H11.25V6.875ZM8.75 13.125V11.875H5.625V10.625H4.375V11.875H1.25V13.125H6.38438C6.15464 14.063 5.67617 14.9217 4.99938 15.6106C4.64459 15.2406 4.34048 14.8251 4.095 14.375H2.70813C3.02579 15.1378 3.48012 15.8361 4.04875 16.4356C3.37879 16.9127 2.64764 17.2974 1.875 17.5794L2.31375 18.75C3.27529 18.3997 4.17904 17.9076 4.995 17.29C5.81457 17.908 6.72188 18.4001 7.68687 18.75L8.125 17.5794C7.3527 17.2979 6.62177 16.9139 5.95187 16.4375C6.8341 15.5253 7.42744 14.373 7.6575 13.125H8.75ZM6.97937 8.125H8.33313L5.46875 1.25H4.11438L1.25 8.125H2.60375L3.125 6.875H6.45813L6.97937 8.125ZM3.64563 5.625L4.79125 2.875L5.9375 5.625H3.64563Z"
        fill="white"
      />
    </svg>
  );
}
